/**
 * admin-console カラー定義
 * service-site のブランドカラーを共有し、管理画面固有のセマンティックトークンを追加
 */
import { defineTokens, defineSemanticTokens } from '@chakra-ui/react';

export const colors = defineTokens.colors({
  // Brand colors (Primary Blue) - service-site と共通
  brand: {
    50: { value: '#EBF3FF' },
    100: { value: '#D6E7FF' },
    200: { value: '#ADC9FF' },
    300: { value: '#85ABFF' },
    400: { value: '#5C8DFF' },
    500: { value: '#1D70FF' },
    600: { value: '#2F76EF' },
    700: { value: '#1A5ACC' },
    800: { value: '#144499' },
    900: { value: '#0E2E66' },
    950: { value: '#071733' },
  },
});

export const semanticColors = defineSemanticTokens.colors({
  // Background - service-site と共通
  bg: {
    DEFAULT: { value: '#F2F4F8' },
    subtle: { value: '#F2F4F8' },
    muted: { value: '#EDF2F7' },
    panel: { value: '#FFFFFF' },
  },

  // Border
  border: {
    DEFAULT: { value: '#EDEFF1' },
  },

  // Surface
  surface: {
    primary: { value: '#FFFFFF' },
    secondary: { value: '#EDF2F7' },
  },

  // Foreground (Text & Icon) - service-site と共通
  fg: {
    DEFAULT: { value: '#414C4F' },
    muted: { value: '#717B8C' },
    subtle: { value: '#AEB4BE' },
    error: { value: '#d4183d' },
  },

  // Brand semantic tokens
  brand: {
    solid: { value: '#1D70FF' },
    contrast: { value: '#FFFFFF' },
    fg: { value: '#2F76EF' },
    muted: { value: '#EBF3FF' },
    subtle: { value: '#D6E7FF' },
    emphasized: { value: '#1A5ACC' },
    focusRing: { value: '#1D70FF' },
  },

  // admin-console 固有トークン（ブランドカラーベース）
  admin: {
    header: {
      bg: { value: '{colors.brand.800}' },
      fg: { value: '#FFFFFF' },
    },
    sidebar: {
      bg: { value: '{colors.brand.900}' },
      fg: { value: '#E8F0FE' },
      hover: { value: '{colors.brand.800}' },
      active: { value: '{colors.brand.700}' },
    },
    table: {
      headerBg: { value: '#F3F4F6' },
      hoverBg: { value: '#F9FAFB' },
      borderColor: { value: '#E5E7EB' },
    },
    error: {
      bg: { value: '#FEF2F2' },
      fg: { value: '#d4183d' },
    },
  },
});
